export default class SearchCart extends HTMLInputElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.bindEvents();
    }

    bindEvents(){
        // Ferme la modale de recherche au click n'importe ou ailleurs
        window.addEventListener('click', function(e){   
            if (document.getElementById('closingCartElmt').contains(e.target)){
                
            } else{
                $(".sv2").removeClass("show");
            }
        });

        $("#search-form-cart").on('submit', function(){
            return false;
        });

        // Lance la recherche ajax quand on tape 3+ caractères
        $(this).on("keyup", (e) => {
            if($(this).val().length >= 3) {
                $.ajax({
                    method: 'GET',
                    url: $(this).data('url'),
                    data: {
                      term: $(this).val(),
                      quickSearch: true,
                      cartSearch: true,
                      cartId: $(this).data('cart'),
                    },
                    success: function success(data) {
                        // Montre la modale et pousse le résultat
                        $(".sv2").addClass("show");
                        $(".sv2").html(data);
                    },
                });
            } else {
                // Cache la modale si on a moins de 3 caractères
                $(".sv2").removeClass("show");
            }
        });
    }
}
